module.exports = __webpack_public_path__ + "img/Station Area Types 1.9bf4dd59.jpg";